import { Controller } from '@hotwired/stimulus'

// Connects to data-controller='employees-list'
export default class extends Controller {
  static targets = [
    'form',
  ]

  declare readonly formTarget: HTMLFormElement

  invite (event: Event) {
    event.preventDefault()
    const button = event.target as HTMLButtonElement
    const realForm = button.closest('form') as HTMLFormElement
    const inputs = document.querySelectorAll<HTMLInputElement>('input[name="selected_employees[invited_employee_ids][]"]')
    inputs.forEach((input: HTMLInputElement) => {
      realForm.appendChild(input)
    })

    realForm.submit()
  }

  terminate (event: Event) {
    event.preventDefault()
    const button = event.target as HTMLButtonElement
    const realForm = button.closest('form') as HTMLFormElement
    const inputs = document.querySelectorAll<HTMLInputElement>('input[name="selected_employees[terminated_employee_ids][]"]')
    inputs.forEach((input: HTMLInputElement) => {
      realForm.appendChild(input)
    })

    realForm.submit()
  }
}
